import { useCallback, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useItemByIdQuery, useItemTagsQuery } from 'api';
import { ADMIN_ROUTES } from 'constants/routes';

export const useDetails = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { id } = useParams() as { id: string };
  const { data: itemDetails = {} } = useItemByIdQuery({ id });
  const { data: itemTags = [] } = useItemTagsQuery();
  const navigate = useNavigate();

  const onModalClose = useCallback(() => {
    setIsOpen(false);
  }, []);
  const onModalOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  const onRedirectToSupplier = useCallback(
    (id: string) => navigate(`${ADMIN_ROUTES.suppliers.view}/${id}/general`),
    [navigate]
  );
  const onRedirectToBrand = useCallback(
    (value: string) => {
      navigate(`${ADMIN_ROUTES.brand.view}/${value}/management`);
    },
    [navigate]
  );

  return {
    isOpen,
    onModalClose,
    onModalOpen,
    itemDetails,
    itemTags,
    onRedirectToSupplier,
    onRedirectToBrand,
  };
};
